<template>
  <ubi-page-container>
    <el-form @submit.prevent.native="fetchList" label-position="top">
      <ubi-panel style="background-color: #EBF3F2;">
        <ubi-search-container
            :filters="filters"
            :defaultFilter="this.filter.preset"
            @filter="doFilter"
            v-on:resetfilter="doFilter('reset')"
            :more-opened="filter.advanced"
            @update:more-opened="advanced => setFilter({ advanced })"
        >
          <el-row :gutter="20">
            <el-col :span="12" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
              <el-form-item :label="$t('general.filters.marchandVo')">
                <el-select
                    v-model="filter.marchand_vo"
                    :placeholder="$t('general.filters.marchandVoPlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="marchandVoChoice in marchandsVo"
                      :key="marchandVoChoice.id"
                      :label="marchandVoChoice.nom"
                      :value="marchandVoChoice.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
              <el-form-item :label="$t('general.filters.brand')">
                <el-select
                    v-model="filter.marque"
                    :placeholder="$t('general.filters.brandPlaceholder')"
                    clearable
                    filterable
                    @change="chargerListeModele(filter.marque)"
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="marqueChoice in marqueVehicule"
                      :key="marqueChoice"
                      :label="marqueChoice"
                      :value="marqueChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
              <el-form-item :label="$t('general.filters.model')">
                <el-select
                    v-model="filter.modele"
                    :placeholder="$t('general.filters.modelPlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="modeleChoice in modeleVehicule"
                      :key="modeleChoice"
                      :label="modeleChoice"
                      :value="modeleChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
              <el-form-item :label="$t('general.filters.energie')">
                <el-select
                    v-model="filter.energie"
                    :placeholder="$t('general.filters.energiePlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="energieChoice in energieVehicule"
                      :key="energieChoice"
                      :label="energieChoice"
                      :value="energieChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
              <el-form-item no-help :label="$t('general.filters.priceMin')">
                <el-input
                    step="100"
                    min="0"
                    type="number"
                    :value="filter.priceGt"
                    @input="priceGt => addFilter({ priceGt })"
                    :placeholder="$t('')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
              <el-form-item no-help :label="$t('general.filters.priceMax')">
                <el-input
                    step="100"
                    min="0"
                    type="number"
                    :value="filter.priceLt"
                    @input="priceLt => addFilter({ priceLt })"
                    :placeholder="$t('')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
              <el-form-item no-help :label="$t('general.filters.kilometrageMin')">
                <el-input
                    step="100"
                    min="0"
                    type="number"
                    :value="filter.kilometrageGt"
                    @input="kilometrageGt => addFilter({ kilometrageGt })"
                    :placeholder="$t('')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
              <el-form-item no-help :label="$t('general.filters.kilometrageMax')">
                <el-input
                    step="100"
                    min="0"
                    type="number"
                    :value="filter.kilometrageLt"
                    @input="kilometrageLt => addFilter({ kilometrageLt })"
                    :placeholder="$t('')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="padding-left: 10px; padding-right: 10px;padding-top:10px;">
              <el-form-item :label="$t('general.filters.achatvo')">
                <el-select
                    v-model="filter.achatvo"
                    :placeholder="$t('general.filters.achatvoPlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="achatvoChoice in achatvoVehicule"
                      :key="achatvoChoice.id"
                      :label="achatvoChoice.nom"
                      :value="achatvoChoice.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </ubi-search-container>
      </ubi-panel>

      <ubi-panel class="PostsList">
        <ubi-list-header
            slot="header"
            :limits="limits"
            :total="results.total"
            :page.sync="page"
            :limit.sync="limit"
            :sort.sync="sort"
            :sortProperties="sortProperties"
        ></ubi-list-header>
        <ubi-list-footer
            slot="footer"
            v-if="results.total > 1"
            :limits="limits"
            :total="results.total"
            :page.sync="page"
            :limit.sync="limit"
            :sort.sync="sort"
            :sortProperties="sortProperties"
        ></ubi-list-footer>

    <ubi-card-container :data="results.list">
      <template
          v-slot="{
            row: {
              id,
              titre,
              etat,
              prixDisplay,
              reference,
              donnees,
              photoPrincipale,
              type,
              sellType,
              typeObjet
            }
          }"
      >
        <ubi-card
            class="PostsList-item PostItem"
            v-model="selected"
            :label="id"
            :id="id"
            full-width
        >
          <template v-slot:headerCheckbox>
            <em></em>
          </template>
          <template v-slot:header>
            <el-row>
              <el-col :span="12">
                <h3 v-if="titre.length <= titrelengthMax">{{ titre | capitalize }}</h3>
                <h3 v-else>{{ titre | reduire(titrelengthMax) }}...</h3>
                <div v-if="titre.length <= 25" style="height: 20px;"></div>
              </el-col>
              <el-col :span="12">
                <div class="text-right PostItem-reference" v-if="reference.length < 15">{{ $t("posts.card.ref") }} : {{ reference }}</div>
                <div class="text-right PostItem-reference" v-else>{{ $t("posts.card.ref") }} : {{ reference | reduireRef }}...</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="PostItem" v-if="donnees.puissance_reelle">{{ donnees.puissance_reelle.valeur }} {{ donnees.puissance_reelle.unite }}</div>
                <div class="PostItem">
                  <span v-if="donnees.kilometrage">{{ donnees.kilometrage.valeur }} {{ donnees.kilometrage.unite }} / </span>
                  <span v-if="donnees.millesime">{{ donnees.millesime.valeur }}</span>
                </div>
                <div class="PostItem">
                  <span v-if="donnees.energie">{{ donnees.energie.valeur }} / </span>
                  <span v-if="donnees.boite_de_vitesse">{{ donnees.boite_de_vitesse.valeur }}</span>
                </div>
                <div class="PostItem-price">{{ prixDisplay }}</div>
              </el-col>
              <el-col :span="12">
                <br /><br /><br />
                <div class="text-right PostItem">{{ donnees.ville.valeur }}</div>
              </el-col>
            </el-row>
          </template>
          <img v-if="photoPrincipale != null" :src="photoPrincipale.url" height="350" alt=""/>
          <div v-else style="text-align: center;"><ubi-icon class="no-photo" name="camera" size='350'/></div>
          <template v-slot:footer>
            <div class="PostItem-actions">
              <div class="PostItem-buttons">
                <el-button-group>
                  <el-button :to="{ name: 'post-view-selection-vo', params: {post: id} }" size="mini" plain>
                    <span>{{ $t("posts.card.details") }}</span>
                  </el-button>
                </el-button-group>
              </div>
            </div>
          </template>
        </ubi-card>
      </template>
    </ubi-card-container>
      </ubi-panel>
    </el-form>
  </ubi-page-container>
</template>

<script>

import {getBrandsOfObjectType, getDefinitionDonneeListeeByCode, getModelsOfBrand, getPosts} from '@/services/posts'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'SelectionVoPostsList',
  components: {
  },
  data () {
    return {
      loading: false,
      filters: [],
      modeleVehicule: [],
      marqueVehicule: [],
      marchandsVo: [
        { id: 'ENTRE_MARCHANDS_AUTO_IMPORT', nom: 'Entre marchands auto' }
      ],
      energieVehicule: [],
      achatvoVehicule: [
        { id: 'lot', nom: this.$t('general.filters.achatLot') },
        { id: 'unite', nom: this.$t('general.filters.achatUnite') }
      ],
      limits: [10, 20, 50],
      selected: [],
      sortProperties: {
      },
      titrelengthMax: 30
    }
  },
  computed: {
    ...mapState('postsVo', ['filter', 'results']),
    saisit_en_ligne () {
      return this.$store.getters.getSitimmoUser.saisit_annonces_en_ligne === true
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.filter.page = value
        this.fetchList()
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        await this.fetchList()
      }
    }
  },
  methods: {
    ...mapMutations('postsVo', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'resetFilter'
    ]),
    async fetchList () {
      this.loading = true
      this.filter.selectionVo = true
      const result = await getPosts(this.filter)
      delete this.filter.selectionVo
      this.setResults(result)
      this.loading = false
      window.scrollTo(500, 0)
    },
    doFilter (type) {
      this.filter.preset = type
      switch (type) {
        case 'reset':
          this.resetFilter()
          break
      }
      this.fetchList()
    },
    async chargerListeModele (brand) {
      this.modeleVehicule = await getModelsOfBrand(brand)
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduire: function (value, lengthMax) {
      if (!value) return ''
      value = value.toString().substr(0, lengthMax)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduireRef: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 15)
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  async beforeMount () {
    if (this.$route.params.reset) {
      this.resetFilter()
    }
    this.marqueVehicule = await getBrandsOfObjectType('11000', true) // 11000 by default
    const donneeEnergie = await getDefinitionDonneeListeeByCode({ codes: 'ENERGIE' })
    if (donneeEnergie && donneeEnergie[0] && donneeEnergie[0].values) {
      this.energieVehicule = donneeEnergie[0].values
    }
    this.filter.page = 1
    this.fetchList()
  }

}

</script>

<style scoped>

</style>
